module.exports = __webpack_public_path__ + "img/winerackdog25.59454b5c.jpg";